module.exports = __webpack_public_path__ + "cc6b1e3e3098c284c5f3fe4bcb11ea4c.svg";